import { render } from "./CustomerSerchComponent.vue?vue&type=template&id=13d58b16&scoped=true&ts=true"
import script from "./CustomerSerchComponent.vue?vue&type=script&lang=ts"
export * from "./CustomerSerchComponent.vue?vue&type=script&lang=ts"

import "./CustomerSerchComponent.vue?vue&type=style&index=0&id=13d58b16&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13d58b16"]])

export default __exports__